import React, { useEffect } from 'react';
import './App.css';
import NavBar from './components/shared/NavBar';
import HeroSection from './components/homepage/HeroSection';
import About from './components/homepage/About';
import Products from './components/homepage/Products';
import ConsultArticles from './components/homepage/ConsultArticles';
import CTA from './components/contact/CTA';
import Footer from './components/shared/Footer';
import ClientTestimonials from './components/homepage/ClientTestimonials';
import UsInAction from './components/homepage/UsInAction';
import WhatsAppButton from './components/shared/WhatsAppButton';
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show'); // Add animation class
          } 
        });
      },
      { threshold: 0.1 } // Trigger when 20% of the element is visible
    );

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect(); // Cleanup on component unmount
  }, []);

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const el = document.getElementById(sectionId);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 200); // small delay ensures component is rendered
      }
    }
  }, [location]);

  return (
    // Homepage content
    <div className="App">
      <NavBar />
      <HeroSection />
      <div id="about" className="hidden">
        <About />
      </div>
      <div id="products" className="hidden">
        <Products />
      </div>
      <div id="in-action" className="hidden">
        <UsInAction />
      </div>
      <div id="client-testimonials" className="hidden">
        <ClientTestimonials />
      </div>
      <div id="consult-articles" className="hidden">
        <ConsultArticles />
      </div>
      <div id="cta" className="hidden">
        <CTA />
      </div>
      <div id="footer" className="hidden">
        <Footer />
      </div>
      <WhatsAppButton />
    </div>
  );
}

export default App;
